module.exports = __webpack_public_path__ + "img/filter-blue.4ebe124a.svg";